import { Language } from "./language";
import { MediaEventMap } from "./mote-event-type";

/** A waypoint comprised of a `location` and an `id` (used when referencing it on the map) */
export type MoteWaypoint = { id: string, location: [number, number], isSnapped: boolean };

// State of mote
export enum MoteState {
    LOCKED = "LOCKED",
    UNLOCKED = "UNLOCKED",
    AVAILABLE = "AVAILABLE",
    INACTIVE = "INACTIVE",
    USERMOTE = "USERMOTE" // TODO: Obsolete: Delete all references to this
}

// Mote lists sorting options
export enum MoteSortType {
    NO_SORTING = 'NO_SORTING',
    ORDER = 'ORDER',
    DISTANCE = 'DISTANCE',
    TITLE = 'TITLE',
    KEY = 'KEY',
    START_DATE = 'START_DATE',
    UPDATED = 'UPDATED'
}

export enum MoteType {
    // Later we might ass a top "Collecton" Mote aka. DbMote or source mote
    COLLECTION = 1,
    ROUTE = 2,
    PLACE = 3,
    EVENT = 4,
    QUEST = 5,
    SCHEDULE = 6
}

export interface MoteData {
    version: number;
    key: string;
    type: MoteType;
    createdBy: string;
    createdOn: any;
    updatedOn: Date;
    publishedOn: Date;
    keyOptimized: boolean;
    deletedOn?: Date;
    parent: string;
    // children: { [moteKey: string]: boolean };
    products: { [productKey: string]: boolean };
    productLocked: boolean;
    price: number;
    duration: number | [number, number];
    storyCount: number;
    startPlace: string;
    endPlace: string;
    city: string;
    country: string;
    startTime: number;
    endTime: number;
    length: number;

    project: string;
    language: Language;
    originKey: string;
    defaultState: MoteState;
    order: number;
    sortBy: MoteSortType;
    unlockMessages: string[];
    tags: string,
    iconSet: string;
    geometry?: any;
    routeGeometry: [number, number][],
    waypoints: MoteWaypoint[],
    position: { lat: number, long: number };
    placeId: string;
    placeIdName: string;
    placeIdIsAttraction: boolean;
    placeIdCheckedOn?: number;
    /** Child story place IDs (tour containers only); TTD export merges with placeId */
    relatedPlaceIds?: string[];
    webflowId: string;
    /** Public storyhunt.io tour page URL (locale-specific); synced from live Webflow slug (SoT). */
    marketingUrl?: string;
    venueKey: string;
    rotation: number;
    previewKey?: string;
    worldCityId?: string;
    hideFromSearch?: boolean;
    hidden?: boolean;
    accumulatedAppReviews?: { avg: number; count: number; updatedOn?: number };
    accumulatedTourReviews?: { avg: number; count: number; updatedOn?: number };

    content?: {
        title: string,
        hideTitle: boolean,
        isCustomTitle: boolean,
        text: string,
        previewText: string,
        externalLink: string,
        externalLinkText: string,
        motesLink: string,
        motesLinkText: string,
        quiz: any,
        media: { [key: string]: any },
        sneakPeakMedia: { [key: string]: any },
        sneakPeekHeader: string
        sneakPeekText: string,
        address: string;
    };

    mediaEventMap: MediaEventMap,
}

export const MoteTypeIconMap: { [key in MoteType]: string } = {
    [MoteType.PLACE]: 'place',
    [MoteType.EVENT]: 'calendar-clear',
    [MoteType.QUEST]: 'medal-solid',
    [MoteType.ROUTE]: 'route',
    [MoteType.COLLECTION]: 'collection',
    [MoteType.SCHEDULE]: 'calendar'
}

/**
 * List mote types that can contain other motes (are tour types)
 */
export const MoteContainerTypes: { [key in MoteType]: boolean } = {
    [MoteType.QUEST]: true,
    [MoteType.ROUTE]: true,
    [MoteType.COLLECTION]: true,
    [MoteType.SCHEDULE]: true,
    [MoteType.PLACE]: false,
    [MoteType.EVENT]: false
}
